export const TableHelpers = {
  data() {
    return {
      tableColumns: [
        {
          title: "Organización",
          type: "custom-html",
          key: "org",
          modifier: (item) => {
            return item ? 'Unidad Técnica - '+item.canton.name : "Matriz";
          },
        },
        {
          title: "Categoría",
          type: "custom-html",
          key: "level_3",
          modifier: (value) => {
            if (value) {
              return value.value;
            } else {
              return "";
            }
            
          },
        },
        {
          title: "Campo de ensayo",
          type: "custom-html",
          key: "level_4",
          modifier: (value) => {
            if (value) {
              return value.value;
            } else {
              return "";
            }
          
          },
        },
        {
          title: "PRODUCTO O MATERIAL A MUESTREAR",
          type: "custom-html",
          key: "product",
          modifier: (value) => {
            return value;
          },
        },
        {
          title:
            "PROCEDIMIENTO DE MUESTREO (Procedimiento normalizado y procedimiento interno, si aplica)",
          type: "custom-html",
          key: "process",
          modifier: (value) => {
            return value;
          },
        },
        {
          title:
            "MÉTODO DE REFERENCIA DEL MUESTREO (revisión/edición) (5)",
          type: "custom-html",
          key: "method",
          modifier: (value) => {
            return value;
          },
        },
        {
          title:
            "MÉTODOS DE ENSAYO A LOS QUE APLICA (Procedimiento interno y/o método de referencia con su revisión/edición)",
          type: "custom-html",
          key: "test_methods",
          modifier: (value) => {
            return value;
          },
        },
      ],
      actionObj: {
        title: "Acción",
        type: "action",
      },
    };
  },
};
